import {useApp2Auth} from "@/app2/auth";

/**
 * OAuth access token for improve-api / WebSocket (manual PropelAuth OAuth via {@link AuthProvider}).
 */
export const useAccessToken = (): string | undefined => {
	const {jwt} = useApp2Auth();
	return jwt;
};
